<app-loader></app-loader>
<div [class.body-content]="applyBodyContentClass">
    <router-outlet (activate)="onRouterOutletActivate($event)" (deactivate)="onRouterOutletDeactivate($event)"></router-outlet>
</div>